import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TournamentEvent } from "../../types/types";

// Define a type for the slice state
interface TournamentEventsState {
  tournamentEvents: Array<TournamentEvent>;
}

// Define the initial state using that type
const initialState: TournamentEventsState = {
  tournamentEvents: [],
};

export const TournamentEventsSlice = createSlice({
  name: "tournamentEvents",
  initialState,
  reducers: {
    setTournamentEvents: (state, action: PayloadAction<Array<TournamentEvent>>) => {
      state.tournamentEvents = action.payload;
    },
    updateTournamentEvent: (state, action: PayloadAction<TournamentEvent>) => {
      state.tournamentEvents = state.tournamentEvents.map((event) =>
        event.id === action.payload.id ? action.payload : event
      );
    },
    updateLocationOnAllTournamentEvents: (
      state,
      action: PayloadAction<{ locationId: string; delay: number }>
    ) => {
      state.tournamentEvents = state.tournamentEvents.map((event) => {
        if (event.location.id === action.payload.locationId) {
          return {
            ...event,
            location: {
              ...event.location,
              delay: action.payload.delay,
            },
          };
        } else {
          return event;
        }
      });
    },
    deleteTournamentEvent: (state, action: PayloadAction<string>) => {
      state.tournamentEvents = state.tournamentEvents.filter(
        (event) => event.id !== action.payload
      );
    },
    createTournamentEvent: (state, action: PayloadAction<TournamentEvent>) => {
      state.tournamentEvents.push(action.payload);
    },
  },
});

export const { setTournamentEvents, updateTournamentEvent, updateLocationOnAllTournamentEvents, deleteTournamentEvent, createTournamentEvent } = TournamentEventsSlice.actions;

export default TournamentEventsSlice.reducer;
